/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureACircleDownIcon20Regular = forwardRef('ArrowFigureACircleDownIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M10 6a.75.75 0 0 1 .75.75v5.193l1.674-2.009a.75.75 0 0 1 1.152.96l-2.231 2.679c-.7.84-1.99.84-2.69 0l-2.231-2.678a.75.75 0 0 1 1.152-.96l1.674 2.008V6.751A.75.75 0 0 1 10 6Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 2.001A7.999 7.999 0 1 1 10 18 7.999 7.999 0 0 1 10 2Zm6.499 8A6.499 6.499 0 1 0 3.5 10 6.499 6.499 0 0 0 16.5 10Z" })));
});
